import { useDowngradeModalContext } from './useDowngradeModalContext';
import { useProductDowngradeData } from './useProductDowngradeData';
export const useDowngradeModal = () => {
  const {
    targetProductId
  } = useDowngradeModalContext();
  const {
    downgradeDetails,
    isLoading,
    downgradeAction,
    isSuccess
  } = useProductDowngradeData({
    productId: targetProductId
  });
  return {
    downgradeDetails,
    isLoading,
    downgradeAction,
    isSuccess
  };
};
//# sourceMappingURL=useDowngradeModal.js.map